//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $ from 'jquery'

export default {
  components: {

  },
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    btnclick () {
      if (this.username === 'ljz' && this.password === '0620') {
        $('audio#cake-music')[0].play()
        let url = '/cake'
        this.$router.push({ path: url })
      } else {
        alert('用户名或密码不正确！')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.vue